<script setup lang="ts">
import useUserSession, { getUserRole } from '/@src/composable/useUserSession'
import { useI18n } from 'vue-i18n'
import { useRouter, useRoute } from 'vue-router'
import Cookies from 'js-cookie'
import storage from '/@src/utils/storage'
const { t } = useI18n()
const router = useRouter()
const route = useRoute()
const userSession = useUserSession()
// const getUserRole = getUserRole()
const handleLogout = () => {
  // 退出登录时，移除code
  const url = new URL(window.location.href)
  url.searchParams.delete('code')
  const redirectPath = url.pathname + url.search
  storage.set('redirect', redirectPath)
  userSession.token = ''
  console.log('userSession',userSession)
  Cookies.set('X-Hufu-Token', '', {
    domain: import.meta.env.VITE_DOMAIN as string,
  })
  router.push({
    name: 'auth-login',
  })
}
</script>
<template>
  <V-Dropdown right spaced class="user-dropdown profile-dropdown">
    <template #button="{ toggle }">
      <a
        class="is-trigger dropdown-trigger"
        aria-haspopup="true"
        @click="toggle"
      >
        <V-Avatar :picture="userSession.user && userSession.user.avatar" />
      </a>
    </template>

    <template #content>
      <div class="dropdown-head">
        <V-Avatar
          size="large"
          :picture="userSession.user && userSession.user.avatar"
        />

        <div class="meta">
          <span>{{ userSession.user && userSession.user.nickname }}</span>
          <span>{{ getUserRole().value }}</span>
        </div>
      </div>

      <a
        v-if="userSession.user"
        :href="'/users/profile/' + userSession.user.id"
        role="menuitem"
        class="dropdown-item is-media"
      >
        <div class="icon">
          <i aria-hidden="true" class="lnil lnil-user-alt"></i>
        </div>
        <div class="meta">
          <span>{{ t('action-user-profile') }}</span>
          <span>{{ t('description-view-profile') }}</span>
        </div>
      </a>

      <hr class="dropdown-divider" />

      <a
        v-if="userSession.user"
        :href="'/content/article/list?userId=' + userSession.user.id"
        role="menuitem"
        class="dropdown-item is-media"
      >
        <div class="icon">
          <i aria-hidden="true" class="lnil lnil-briefcase"></i>
        </div>
        <div class="meta">
          <span>{{ t('action-profile-popup-my-articles') }}</span>
          <span>{{ t('description-profile-popup-my-articles') }}</span>
        </div>
      </a>

      <hr class="dropdown-divider" />

      <a
        v-if="userSession.user"
        :href="'/users/profile/' + userSession.user.id + '/settings'"
        role="menuitem"
        class="dropdown-item is-media"
      >
        <div class="icon">
          <i aria-hidden="true" class="lnil lnil-cog"></i>
        </div>
        <div class="meta">
          <span>{{ t('action-profile-popup-setting') }}</span>
          <span>{{ t('description-profile-popup-my-setting') }}</span>
        </div>
      </a>

      <hr class="dropdown-divider" />

      <div class="dropdown-item is-button">
        <V-Button
          class="logout-button"
          icon="feather:log-out"
          color="primary"
          role="menuitem"
          raised
          fullwidth
          @click="handleLogout"
        >
          {{ t('text-logout') }}
        </V-Button>
      </div>
    </template>
  </V-Dropdown>
</template>
